<template>
  <v-card class="py-4 px-5">
    <h2 class="info-title mb-2">{{ $t('section.general_info') }}</h2>
    <p class="info-hint mb-4">{{ $t('section.general_info__hint') }}</p>
    <div v-for="({ title, key, format }, index) in infoBlocks" :key="index" class="mb-2">
      <div class="text--disabled">{{ title }}</div>
      <div class="">{{ getValue(key, format) }}</div>
    </div>
  </v-card>
</template>

<script>
import { formatDate } from '@/helpers/intl';
import { mapState } from 'vuex';

export default {
  name: 'PersonalInfo',
  methods: {
    getValue(key, format) {
      const value = this.employeeInfo[key];

      if (format && value) {
        return format(value);
      }

      return value || '---';
    },
  },
  computed: {
    ...mapState('candidate', ['employeeInfo']),
    infoBlocks() {
      return [
        {
          title: this.$t('section.start_date'),
          key: 'start_date',
          format: formatDate,
        },
        {
          title: this.$t('section.position'),
          key: 'position',
        },
        {
          title: this.$t('section.department'),
          key: 'department',
        },
        {
          title: this.$t('section.project'),
          key: 'project',
        },
        {
          title: this.$t('section.manager'),
          key: 'manager',
        },
        {
          title: this.$t('section.mentor'),
          key: 'mentor',
        },
        {
          title: this.$t('section.hr_organizer'),
          key: 'hr_organizer',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.info-title {
  font-size: 0.9375rem;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 400;
}

.info-hint {
  font-size: 0.9rem;
  opacity: 0.8;
}
</style>
